import React from "react";
import { getNormalizedColSpans } from "./../../../../../ricos-common-plugins/layout/get-normalized-col-spans.js";
import { RicosNodeContextProvider } from "./../../../../../ricos-context/index.js";
import styles from "./layout-scss.js";
const getGridTemplateColumnsTemplate = (node) => {
  const cols = [];
  node.nodes.forEach((cell) => {
    if (cell.type === "LAYOUT_CELL") {
      cols.push(cell.layoutCellData?.colSpan ?? 0);
    }
  });
  return getNormalizedColSpans(cols).map((col, i) => {
    if (i === 0 || i === cols.length - 1) {
      return `minmax(0, calc(((100% + 2 * var(--ricos-layout-horizontal-padding)) * ${col} / 12) - var(--ricos-layout-horizontal-padding)))`;
    }
    return `minmax(0, ${col}fr)`;
  }).join(" ");
};
const Layout = ({ node, nodeIndex, RicosNodesRenderer }) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.layout,
      style: {
        "--ricos-layout-column-template": getGridTemplateColumnsTemplate(node)
      }
    },
    /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { key: `children-${node.id}`, nodes: node.nodes ?? [] }))
  );
};
const LayoutRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Layout, { key: node.id, node, ...props });
};
export {
  Layout,
  LayoutRenderer
};
//# sourceMappingURL=layout.js.map
